import { useTRPC } from "../../../../trpc/client";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useApproveWithdrawal(
  onSuccess?: () => void,
  onError?: (error: unknown) => void
) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();
  const queryClient = useQueryClient();

  const approveMutation = useMutation({
    ...trpc.withdrawals.approve.mutationOptions(),
    onSuccess,
    onError,
  });

  const approveWithdrawal = (id: string, otp?: string) => {
    if (!merchant?.id) return;

    approveMutation.mutate(
      { rentalsMerchantId: merchant.id, id, otp },
      {
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: trpc.withdrawals.list.queryKey(),
          });
          queryClient.invalidateQueries({
            queryKey: trpc.ledgerMovements.getBalance.queryKey(),
          });
          queryClient.invalidateQueries({
            queryKey: trpc.ledgerMovements.list.queryKey(),
          });
        },
      }
    );
  };

  return { approveWithdrawal, isApproving: approveMutation.isPending };
}
